<template>
    <div class="schedulesmslogVue">
        <div class="o-main-content-area">
            <div class="o-page-top-heading c-responsive-fixwidth">
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-6">
                        <p class="u-back">
                            <a href="javascript: void(0)" @click="backToCalender()"><i class="fa fa-chevron-left"></i> Back </a>
                        </p>
                        <h1 class="h1">Preview of Job Deleted on {{getGlobalDate(preview.jobs.deleted_at)}}</h1>
                    </div>
                    <div class="col-md-6 text-right">
                        <ul class="o-filter-area">                      
                        </ul>
                    </div>
                </div>
                <div class="c-common-space c-common-space--overflowVisible clearfix">
                    <div class="col-md-12 o-no-padding">
                        <div class="custom-row">
                            <div class="custom-col text-left">
                                <ul class="o-custom-filter-new">
                                    <li><span class="o-blue-medium-text">Jobs / Events:</span> <span>{{preview?preview.jobs.title:''}}</span></li>
                                    <li><span class="o-blue-medium-text">Venue:</span> <span>{{preview?preview.jobs.venue:''}}</span></li>
                                </ul>
                            </div>
                            <div class="custom-col outer--border text-left">
                                <ul class="o-custom-filter-new">
                                    <li><span class="o-blue-medium-text">Start Date:</span> <span>{{preview?getGlobalDate(preview.jobs.start):''}}</span></li>
                                    <li><span class="o-blue-medium-text">End Date:</span> <span>{{preview?getGlobalDate(preview.jobs.end):''}}</span></li>
                                </ul>
                            </div>
                            <div class="custom-col outer--border text-left">
                                <ul class="o-custom-filter-new">
                                    <li><span class="o-blue-medium-text">Employer:</span> <span>{{preview ? preview.jobs.employer:"NA"}}</span></li>
                                    <li><span class="o-blue-medium-text">Job No:</span> <span>{{preview ? preview.jobs.job_number : "NA"}}</span></li>
                                </ul>
                            </div>
                            <div class="custom-col text-left">
                                <ul class="o-custom-filter-new">
                                    <li><span class="o-blue-medium-text">Steward:</span> 
                                        <span >{{preview?preview.jobs.Steward:'---'}}</span>
                                    </li>
                                    <li>
                                        <span class="o-blue-medium-text">Created by:</span> 
                                        <span >{{preview?preview.jobs.created_by:'---'}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable" 
                infinite-scroll-disabled="busy" 
                infinite-scroll-distance="10"
                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                ref="scrollContainer"
                style="min-height: 1px;"
            >
                <div class="o-ndividualTable">
                    <div v-for="(call, id) in preview.calls" :key="id" class="o-custom-table-container c-common-box-shadow c-radius3 sms-list-table-align o-overflow-visible">
                        <div class="o-calls-table c-common-gradient o-overflow-visible tableList-padding">
                            <div class="calls-table-row phonesheet-table-row">
                                
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Position:</span>
                                                <div>{{call.skill}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Employee:</span>
                                            <div v-if="call.status !='Unassigned'">{{call.employee_last_first_name}}</div>
                                            <div v-if="call.status =='Unassigned'">{{call.employee_last_first_name}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Start:</span>
                                                <div>{{getTime(call.start)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>End:</span>
                                                <div>{{getTime(call.end)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Notes:</span>
                                        <div>{{call.call_notes.length==0?'---':call.call_notes}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>  
                                              
            </div>          
        </div>
    </div>
</template>

<script>
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../services.js';
    import { global } from '../../global.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters } from 'vuex';
    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                callSettingsPast:{},
                callSettingsFuture:{},
                calls:[],
                lastDate:'',
                afterAPI:'',
                storeMore:[],
                preview: null,
                job:null,
                isPast:true,
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userRoleSlug: 'userRoleSlug',
            })
        },
        methods: {
            backToCalender(){
                this.$router.go(-1);
            },
            goToCalls(){
                this.$store.dispatch('setSelectedCallList', 'bulk');
                this.$router.push({
                    path: `/viewCalls/`+ this.$route.params.jobId
                });
            },
            goToPhoneSheet(){
                this.$router.push({
                    path: `/phoneSheet/`+ this.$route.params.jobId
                });
            },
            goToJobDetails(){
                this.$router.push({
                    path: `/jobDetails/`+ this.$route.params.jobId
                });
            },
            footerAccess(){
              if(this.userRoleSlug=='employee')
                return false;
              else
                return true;
            },
            changeSortType(e){
                this.sortCalls(e.target.value);
            },
            previewCallList(){
                service.post('job/' + atob(this.$route.params.jobId) + '/restoreJob', {
                    'restore_option': 'preview',
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userid': this.userID,
                }).then((res) => {
                    this.preview = res["data"].result;
                }).catch((err) => {
                    console.log(err);
                });
            },
            sortCalls(type) {
                let self = this;
                switch (type) {
                    case 'call_times':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                var dateA = moment(a.start);
                                var dateB = moment(b.start);
                                return dateA > dateB ? 1 : -1;
                            });
                        }
                        break;
                    case 'call_status':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                if (a.status.name < b.status.name) return 1;
                                if (a.status.name > b.status.name) return -1;
                                return 0;
                            });
                        }
                        break;
                    case 'position':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                if (a.skill.priotiy < b.skill.priotiy) return -1;
                                if (a.skill.priotiy > b.skill.priotiy) return 1;
                                return 0;
                            });
                        }
                        break;
                    case 'seniority':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                if(a.employee && a.employee["seniority"]){
                                    if (a.employee.seniority < b.employee.seniority) return -1;
                                    if (a.employee.seniority > b.employee.seniority) return 1;
                                    return 0;
                                }
                                return 0;
                            });
                        }
                        break;
                    case 'employee_name':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                let nameA = a.employee && a.employee["employable"] ? a.employee.employable.last_name+' '+a.employee.employable.first_name:'zzzzzz';
                                let nameB = b.employee && b.employee["employable"] ? b.employee.employable.last_name+' '+b.employee.employable.first_name:'zzzzzz';
                                if (nameA < nameB) return -1;
                                if (nameA > nameB) return 1;
                                return 0;
                            });
                        }
                        break;
                    default:
                }
            },
            getAllCalls() {
                this.$Progress.start();
                service.get('job/' + atob(this.$route.params.jobId) + '/call', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).then((res) => {
                    this.calls = res.data.result;
                    this.$Progress.finish();
                    this.afterAPI = true;
                    this.lastDate = Object.keys(this.calls)[Object.keys(this.calls).length - 1] + " " + Date().slice(16, 24);
                    service.get('job/' + atob(this.$route.params.jobId) + '/call', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'nextDate': this.lastDate,
                    }).then((res) => {
                        this.storeMore = res.data.result;
                        if (this.storeMore.length != 0) {
                            this.lastDate = Object.keys(this.storeMore)[Object.keys(this.calls).length - 1] + " " + Date().slice(16, 24);
                        } else {
                            this.lastDate = '';
                        }                                    
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch((err) => {
                    console.log(err);
                    this.afterAPI = true;
                    this.$Progress.finish();
                });
            }, 

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                if (this.storeMore.length != 0) {
                    this.calls = Object.assign({}, this.calls, this.storeMore);
                    this.storeMore = [];
                    if (this.lastDate != '') {
                        await service.get('job/' + atob(this.$route.params.jobId) + '/call', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'nextDate': this.lastDate,
                            })
                            .then((res) => {
                                this.storeMore = res.data.result;
                                if (this.storeMore.length != 0) {
                                    this.lastDate = Object.keys(this.storeMore)[Object.keys(this.calls).length - 1] + " " + Date().slice(16, 24);
                                } else {
                                    this.lastDate = '';
                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    } else {
                        this.storeMore = [];
                    }
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            }, 

            getDate(dateTime) {
                return dateTimeConvert.localDateFull(dateTime);
            },

            getGlobalDate(dateTime){
                return dateTimeConvert.localDate(dateTime);
            },

            getTime(dateTime) {
                return moment(dateTime).format('MM/DD/YYYY @ hh:mm A');
            },

            getNotify(notified, marked){
                if(notified && marked){
                    if(moment(notified)>moment(marked)){
                        return dateTimeConvert.utcTimeToUserTime(notified);
                    }
                    return dateTimeConvert.utcTimeToUserTime(marked);
                }else if(marked){
                    return dateTimeConvert.utcTimeToUserTime(marked);
                }else if(notified){
                    return dateTimeConvert.utcTimeToUserTime(notified);
                }
                return "---"
            },
            checkElement(value){
                if(this.isPast){
                    for (var key in this.callSettingsPast) {
                        if(this.callSettingsPast[key]==value){
                            return true;
                        }
                    }
                }else{
                    for (var key in this.callSettingsFuture) {
                        if(this.callSettingsFuture[key]==value){
                            return true;
                        }
                    }
                }
                return false;
            },
            getClientSettings(){
                service.get('client/' + this.userClientID, {
                  'Authorization': this.userToken
              })
              .then((client) => {
                this.callSettingsPast=client.data.result.settings['job-info-config-past'];
                this.callSettingsFuture=client.data.result.settings['job-info-config-future'];
              }).catch((err) => {
                  console.log(err);
              });
            },
            jobDetails() {
                this.$Progress.start();
                service.get('job/' + atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.$store.dispatch('setJob', res.data.result);
                    this.job = res.data.result;
                    this.jobStatus=this.job.status.name;
                    this.notes = res.data.result.notes;
                    this.attachmentList = res.data.result.attachments;

                    this.jobStart = new Date(this.job.start);
                    this.jobStart.setDate(this.jobStart.getDate() - 1);
                    this.jobEnd = new Date(this.job.end);
                    this.checkJob(this.job.end);
                    this.$Progress.finish();
                }).catch((err) => {
                    console.log(err);
                });
            },
            checkJob(endDate){
                if(moment(endDate).format('YYYY-MM-DD')<moment().format('YYYY-MM-DD')){
                    this.isPast=true;
                }else{
                    this.isPast=false;
                }
            },
        },

        beforeMount() {
            this.previewCallList();
        }
    }

</script>
<style scoped>
.o-main-content-area {
    padding: 75px 30px 0px 50px;
}
.o-custom-filter-new{
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
}
.sms-list-table-align .calls-table-row .calls-table-cell:nth-child(4) {
    text-align: left;
    width: 220px;
}

</style>
